/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_StaatsangehoerigkeitInputs */

const en__field_staatsangehoerigkeit = /** @type {(inputs: _Field_StaatsangehoerigkeitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nationality`)
};

const de__field_staatsangehoerigkeit = /** @type {(inputs: _Field_StaatsangehoerigkeitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Staatsangehörigkeit`)
};

/**
* | output |
* | --- |
* | "Nationality" |
*
* @param {_Field_StaatsangehoerigkeitInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_staatsangehoerigkeit = /** @type {((inputs?: _Field_StaatsangehoerigkeitInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_StaatsangehoerigkeitInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_staatsangehoerigkeit(inputs)
	return de__field_staatsangehoerigkeit(inputs)
});